export default __webpack_public_path__ + "static/media/virgo.d5bdd7dc.png";